import React from "react"
import types from "prop-types"
import ItemRow from "shared/ItemRow"
import { FormIcon } from "shared/icons"
import TruncatedWithTooltip from "shared/TruncatedWithTooltip"
import { unpaddedNumberDate } from "utils/dateHelpers"
// eslint-disable-next-line max-len
import SurveyTokenPublicStatus from "views/Surveys/SurveyBatchShow/SurveyBatchTabs/SubmissionsContent/SurveyBatchSurveyTokens/SurveyTokenPublicStatus"
// eslint-disable-next-line max-len
import SurveyCopyLink from "views/Surveys/SurveyBatchShow/SurveyBatchTabs/SubmissionsContent/SurveyBatchSurveyTokens/SurveyCopyLink"

const SurveyRecipientRow = ({ surveyRecipient }) => {
  const { contact } = surveyRecipient

  const recipientName = (contact.lastName || contact.firstName)
    ? `${contact.lastName || ""}, ${contact.firstName || ""}`
    : ""

  return (
    <ItemRow
      collapsable
      itemRowHeaderContent={(
        <div className="survey-recipient-list-row">
          <FormIcon form={surveyRecipient.form} className="h-6 w-6" />
          <span>{unpaddedNumberDate(surveyRecipient.batchDate)}</span>
          <TruncatedWithTooltip text={surveyRecipient.batchName} />
          <TruncatedWithTooltip text={recipientName} />
          <TruncatedWithTooltip text={contact.email} className="font-normal" />
          <SurveyTokenPublicStatus
            formSubmissionSlug={surveyRecipient.formSubmissionSlug}
            publicStatus={surveyRecipient.publicStatus}
          />
        </div>
      )}
      itemRowBody={(
        <div className="font-normal w-full">
          <div className="mb-3">
            <div className="font-semibold">
              Form
            </div>
            <span>
              {surveyRecipient.form.title}
            </span>
          </div>
          <div className="mb-3">
            <div className="font-semibold">
              Comment
            </div>
            <span>
              {surveyRecipient.comment}
            </span>
          </div>
          <div className="mb-3">
            <div className="font-semibold">
              Reminder cc
            </div>
            <div className="break-all">
              {surveyRecipient.reminderCcEmail}
            </div>
          </div>
          <div className="mb-3">
            <div className="font-semibold">
              Survey Link
            </div>
            <SurveyCopyLink url={surveyRecipient.url} />
          </div>
        </div>
      )}
    />
  )
}

SurveyRecipientRow.propTypes = {
  surveyRecipient: types.object.isRequired,
}

export default SurveyRecipientRow
